import moment from "moment";

// Components
import Status, { STATUS_TYPES } from "../../../components/molecules/status";
import Button, { BUTTON_TYPES } from "../../../components/atoms/button";
import { EditOutlined, DeleteOutlined, FolderOpenOutlined } from "../../../components/atoms/icon";
import { Switch } from 'antd';

// Readers
import freelancerReader from "../../../readers/freelancer";

// Styles
import styles from "../freelancers.module.scss";

const createColumns = ({ onEdit, onDelete, onInActive, onOpenAccount, onPageChange }) => {
  return [
    {
      title: <span style={{ color: "#cf9c46" }}>Name</span>,
      dataIndex: 'firstName',
      sorter: true,
      render: (text, freelancerDetails) => {
        return `${freelancerReader.firstName(
          freelancerDetails
        )} ${freelancerReader.lastName(freelancerDetails)}`;
      },
    },
    {
      title: <span style={{ color: "#cf9c46" }}>Email</span>,
      dataIndex: 'email',
      sorter: true,
      render: (text, freelancerDetails) => {
        return freelancerReader.email(freelancerDetails);
      },
    },
    {
      title: <span style={{ color: "#cf9c46" }}>Manage Account</span>,
      render: (text, freelancerDetails) => {
        return <Button
          type={BUTTON_TYPES.DEFAULT}
          onClick={(event) => {
            event.stopPropagation();
            onOpenAccount(freelancerDetails);
          }}
          className={`${styles.icon}`}
        >
          <FolderOpenOutlined />
        </Button>

      },
    },
    {
      title: <span style={{ color: "#cf9c46" }}>Posts</span>,
      render: (text, freelancerDetails) => {
        const count = freelancerReader.postsCount(freelancerDetails)
        const id = freelancerReader.id(freelancerDetails)
        return (
          <Button
            disabled={count ? false : true}
            type={BUTTON_TYPES.DEFAULT}
            onClick={(event) => {
              event.stopPropagation();
              onPageChange(`/posts/${id}`);
            }}
          >
            {count}
          </Button>
        );
      },
    },
    // {
    //   title: "Role",
    //   render: (text, freelancerDetails) => {
    //     return freelancerReader.role(freelancerDetails);
    //   },
    // },
    {
      title: <span style={{ color: "#cf9c46" }}>Last Use</span>,
      sorter: true,
      dataIndex: 'lastOpen',
      render: (text, freelancerDetails) => {
        const lastOpen = freelancerReader.lastOpen(freelancerDetails)
        return lastOpen ? moment(lastOpen).fromNow() : null;
      },
    },
    {
      title: <span style={{ color: "#cf9c46" }}> Version</span>,
      render: (text, freelancerDetails) => {
        const appVersionAndroid = freelancerReader.appVersionAndroid(freelancerDetails)
        const appVersionIOS = freelancerReader.appVersionIOS(freelancerDetails)
        return <>
          {appVersionAndroid ?
            <div className={styles.appVersion}>Android : <strong>{appVersionAndroid}</strong></div>
            : null}
          {appVersionIOS ?
            <div className={styles.appVersion}>IOS : <strong>{appVersionIOS}</strong></div>
            : null
          }
        </>
      },
    },
    {
      title: <span style={{ color: "#cf9c46" }}>Status</span>,
      render: (text, freelancerDetails) => {
        const status = freelancerReader.isActive(freelancerDetails)
        const user_id = freelancerReader.id(freelancerDetails)
        return <Switch
          checked={status}
          onClick={(bolean, event) => {
            event.stopPropagation();
            onInActive(user_id, !status);
          }}
        />
      },
    },
    {
      title: <span style={{ color: "#cf9c46" }}>Actions</span>,
      render: (text, freelancerDetails) => {
        return (
          <>
            <Button
              type={BUTTON_TYPES.LINK}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(freelancerDetails);
              }}
              className={styles.icon}
            >
              <EditOutlined />
            </Button>
            <Button
              disabled
              type={BUTTON_TYPES.LINK}
              onClick={(event) => {
                event.stopPropagation();
                onDelete(freelancerDetails);
              }}
              className={`${styles.icon} ${styles.iconDanger}`}
            >
              <DeleteOutlined />
            </Button>
          </>
        );
      },
    },
  ];
};

export { createColumns };
